import { BodyShapeOptionsType } from './types';

export const BODY_SHAPE_OPTIONS: BodyShapeOptionsType = [
  {
    id: 'skinny',
    title: 'Skinny',
  },
  {
    id: 'regular',
    title: 'Regular',
  },
  {
    id: 'athletic',
    title: 'Athletic',
  },
  {
    id: 'plus_size',
    title: 'Plus size',
  },
];
